import Footer from '../components/Footer/Footer';
import styled from 'styled-components';
import mindfulness from '../assets/images/mindfulness.svg';

const PageWrapper = styled.div`
  background: linear-gradient(160deg, #f5f7f2 0%, #e8ede3 100%);
  min-height: 100vh;
`;

const HeroSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 1.5rem 2rem;
`;

const Illustration = styled.img`
  width: 100%;
  max-width: 340px;
  margin-bottom: 1.5rem;
  filter: drop-shadow(0 8px 24px rgba(70, 90, 59, 0.15));
`;

const PageTitle = styled.h1`
  font-size: 2.4rem;
  font-weight: 700;
  color: #465a3b;
  text-align: center;
  margin-bottom: 0.5rem;
  letter-spacing: -0.5px;

  @media (max-width: 767px) {
    font-size: 1.8rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #6b7c5e;
  text-align: center;
  margin-bottom: 0;
`;

const CardSection = styled.section`
  max-width: 760px;
  margin: 0 auto;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 2rem 2.5rem;
  box-shadow: 0 2px 16px rgba(70, 90, 59, 0.08);
  border-left: 5px solid ${({ accent }) => accent || '#465a3b'};
  font-size: 1.1rem;
  line-height: 1.8;
  color: #343434;

  @media (max-width: 767px) {
    padding: 1.5rem;
  }
`;

const CardLabel = styled.p`
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${({ accent }) => accent || '#465a3b'};
  margin-bottom: 0.5rem;
`;

const EmergencyPhone = styled.a`
  display: inline-block;
  margin-top: 0.5rem;
  font-size: 1.4rem;
  font-weight: 700;
  color: #465a3b;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: #2f3f29;
  }
`;

const Signature = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #343434;
  margin: 0;

  strong {
    display: block;
    margin-top: 0.25rem;
    font-size: 1.2rem;
    color: #465a3b;
  }
`;

export default function VacationNoticePage() {
  return (
    <>
      <div className="vacation-notice-layout">
        <PageWrapper>
          <HeroSection>
            <Illustration src={mindfulness} alt="Relaxing vacation illustration" />
            <PageTitle>Clinic Vacation Notice</PageTitle>
            <Subtitle>September 2 – 17, 2026</Subtitle>
          </HeroSection>

          <CardSection>
            <Card accent="#465a3b">
              <CardLabel accent="#465a3b">Notice</CardLabel>
              <p style={{ margin: 0, fontSize: '1.25rem' }}>
                I will be away on vacation{' '}
                <strong>from September 2nd to September 17th, 2026</strong>. During this time, I
                won't be available for appointments or consultations.
              </p>
            </Card>

            <Card accent="#e08e0b">
              <CardLabel accent="#e08e0b">Non-emergency care</CardLabel>
              <p style={{ margin: 0, fontSize: '1.25rem' }}>
                For any non-emergency veterinary care, you're welcome to contact{' '}
                <strong>Fisher Mills Animal Hospital</strong>.
              </p>
              <EmergencyPhone href="tel:+15192602900">(519) 260-2900</EmergencyPhone>
            </Card>

            <Card accent="#c0392b">
              <CardLabel accent="#c0392b">🚨 In case of an emergency</CardLabel>
              <p style={{ margin: 0, fontSize: '1.25rem' }}>
                Please reach out to <strong>Campus Estates Animal Hospital</strong> or the nearest
                emergency veterinary hospital.
              </p>
            </Card>

            <Card accent="#978e7d">
              <CardLabel accent="#978e7d">A note from Dr. Nas</CardLabel>
              <p style={{ margin: 0, fontSize: '1.25rem' }}>
                Thank you for your understanding and continued trust in our services. We appreciate
                the opportunity to care for your pets and look forward to seeing you again when we
                return.
              </p>
              <br />
              <Signature>
                Warm regards,
                <strong>- Dr. Nas, DVM</strong>
              </Signature>
            </Card>
          </CardSection>
        </PageWrapper>

        <Footer />
      </div>
    </>
  );
}
